import debounce from "lodash/debounce";
import heroState from "./event-hero.js";

(function () {
  // escape hatch
  if (document.querySelector(".event-hero") === null) return;

  const hero = document.querySelector(".event-hero");
  const heroMedia = hero.querySelector(".hero-media");
  const backToTop = hero.querySelector(".hero-toplink-link");

  // handle floating video
  function handleHeroFloat() {
    if (
      !["youtube", "vimeo", "ivs"].includes(heroState.media.type) ||
      heroState.currentType === "plastic"
    ) {
      hero.style.height = "";
      document.body.classList.remove("is-floating");
      return;
    }

    let heroOffset = hero.getBoundingClientRect().top + window.scrollY,
      heroHeight = hero.offsetHeight,
      scrollPos = document.body.getBoundingClientRect().top * -1;

    if (scrollPos > heroOffset + heroHeight - 150) {
      // ? 150 = sticky header height + basic infobar height
      hero.style.height = heroHeight + "px";
      document.body.classList.add("is-floating");
    } else {
      hero.style.height = "";
      document.body.classList.remove("is-floating");
    }
  }

  // handle body scroll class
  function handleScrollClass() {
    if (window.scrollY !== 0) {
      document.body.classList.add("is-scrolled");
      return;
    }
    document.body.classList.remove("is-scrolled");
  }

  // scroll to top button
  backToTop.addEventListener("click", function () {
    hero.style.height = "";
    document.body.classList.remove("is-floating");
    window.scrollTo(0, 0);
  });

  // event handlers
  window.addEventListener(
    "scroll",
    debounce(function () {
      handleScrollClass();
      handleHeroFloat();
    }),
    100
  );
})();
